/**
 * @generated SignedSource<<abed07fa3706eaaeb09709b1a1002587>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type OnboardingType = "CLIENT" | "CONTRACTOR" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ProfileServices_userProfile$data = {
  readonly displayUsername: string;
  readonly firstName: string | null;
  readonly id: string;
  readonly onboardingType: OnboardingType;
  readonly productizedServices: {
    readonly count: number;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"ProductizedServiceCardDataWrapper">;
      };
    }>;
  };
  readonly visitorCanEdit: boolean;
  readonly " $fragmentType": "ProfileServices_userProfile";
};
export type ProfileServices_userProfile$key = {
  readonly " $data"?: ProfileServices_userProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileServices_userProfile">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileServices_userProfile",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayUsername",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitorCanEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "onboardingType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserProfileProductizedServiceConnection",
      "kind": "LinkedField",
      "name": "productizedServices",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "UserProfileProductizedServiceEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProductizedService",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ProductizedServiceCardDataWrapper"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UserProfile",
  "abstractKey": null
};
})();

(node as any).hash = "1a9ebb28d765148082c4e78f47d9d338";

export default node;
